import { render, staticRenderFns } from "./ScoringProfilesDefinition.vue?vue&type=template&id=34285c10&scoped=true"
import script from "./ScoringProfilesDefinition.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesDefinition.vue?vue&type=script&lang=js"
import style0 from "./ScoringProfilesDefinition.vue?vue&type=style&index=0&id=34285c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34285c10",
  null
  
)

export default component.exports